import { getDriversCalendarHistory, isHistoryChanged } from './DriverCalendarHistory';
import { historyIdentity, subscribeHistoryIdentity } from './HistoryRequests';

// One report owns its current page, not a responsive list or a query cache.
export const createHistoryTraversal = (selection, load = getDriversCalendarHistory) => {
  let generation = 0;
  let controller;
  let conflicts = 0;
  const listeners = new Set();
  const report = {
    selection, page: 1, snapshot: undefined, identity: historyIdentity(),
    state: { isFetching: true },
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
    publish(state) { report.state = state; listeners.forEach((listener) => listener()); },
    async fetch(page = 1, restart = false) {
      if (controller) controller.abort();
      controller = new AbortController();
      const current = ++generation;
      if (restart) report.snapshot = undefined;
      report.page = page;
      report.publish({ isFetching: true });
      try {
        const drivers = await load({ page, selection: report.selection, snapshot: report.snapshot, signal: controller.signal });
        if (current !== generation || report.identity !== historyIdentity()) return;
        report.snapshot = drivers.snapshot;
        report.publish({ drivers, isFetching: false });
      } catch (error) {
        if (current !== generation || report.identity !== historyIdentity()) return;
        if (isHistoryChanged(error)) {
          report.snapshot = undefined;
          report.page = 1;
          if (conflicts++ === 0) return report.fetch(1, true);
        }
        report.publish({ error, isError: true, isFetching: false, historyChanged: isHistoryChanged(error) });
      }
    },
    retry() { conflicts = 0; return report.fetch(1, true); },
    conflict(error) {
      if (!isHistoryChanged(error)) return;
      report.snapshot = undefined;
      if (conflicts++ === 0) report.fetch(1, true);
      else {
        if (controller) controller.abort();
        generation += 1;
        report.page = 1;
        report.publish({ error, isError: true, historyChanged: true, isFetching: false });
      }
    },
    dispose() { generation += 1; if (controller) controller.abort(); },
  };
  report.watchIdentity = () => subscribeHistoryIdentity(() => {
    report.dispose();
    report.snapshot = undefined;
    report.publish({ isFetching: false, isError: true, error: { status: 401 } });
  });
  return report;
};
